import { render, staticRenderFns } from "./VatRateValue.vue?vue&type=template&id=3819788e&"
import script from "./VatRateValue.vue?vue&type=script&lang=ts&"
export * from "./VatRateValue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports